module.exports = require("vtk.js/Sources/Widgets/Core/WidgetManager/Constants");